import { render, staticRenderFns } from "./NewsEditModal.vue?vue&type=template&id=447ff36a&scoped=true"
import script from "./NewsEditModal.vue?vue&type=script&lang=js"
export * from "./NewsEditModal.vue?vue&type=script&lang=js"
import style0 from "./NewsEditModal.vue?vue&type=style&index=0&id=447ff36a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447ff36a",
  null
  
)

export default component.exports